import ToolServices from '@/providers/tools';

export const PREFERENCES_STORE_NAME = 'PreferencesStore';

export const PREFERENCES_API = {
  GET_ORGANIZATION_PREFERENCES: 'organization/internal/organization/{organizationId}/preference',
  SET_ORGANIZATION_PREFERENCES: 'organization/internal/organization/{organizationId}/preference',
  GET_CONTENT_PREFERENCES: 'content/{contentId}/preference',
  GET_CLASS_CONTENT_PREFERENCES: 'classes/class/{classId}/courses/{contentId}/preference',
  USER_CONTENT_PREFERENCES: 'classes/class/{classId}/courses/{contentId}/user/{userId}/preference',
}

export const PREFERENCES_MUTATIONS = {
  SET_ORGANIZATION_PREFERENCES: 'setOrganizationPreferences',
  UPDATE_ORGANIZATION_PREFERENCES: 'updateOrganizationPreferences',
  SET_CLASS_CONTENT_PREFERENCES: 'setClassContentPreferences',
  SET_USER_CONTENT_PREFERENCES: 'setUserContentPreferences',
  UPDATE_USER_CONTENT_PREFERENCES: 'updateUserContentPreferences',
}

export const PREFERENCES_ACTIONS = {
  GET_ORGANIZATION_PREFERENCES: 'getOrganizationPreferences',
  SAVE_ORGANIZATION_PREFERENCES: 'saveOrganizationPreferences',
  GET_USER_CONTENT_PREFERENCES: 'getUserContentPreferences',
  GET_CONTENT_PREFERENCES: 'getContentPreferences',
  GET_CLASS_CONTENT_PREFERENCES: 'getClassContentPreferences',
  SAVE_USER_CONTENT_PREFERENCES: 'saveUserContentPreferences',
}

export const PREFERENCES_STORE = ToolServices.getStore(
  PREFERENCES_STORE_NAME,
  PREFERENCES_ACTIONS,
  PREFERENCES_MUTATIONS
);

export const PREFERENCES_KEYS = {
  TIME_FRAME_CONTENT_VIEW_END: 'TIME_FRAME_CONTENT_VIEW_END',
  TIME_FRAME_CONTENT_VIEW_START: 'TIME_FRAME_CONTENT_VIEW_START',
  TIME_FRAME_CONTENT_ENABLED_BY_TEACHER: 'TIME_FRAME_CONTENT_ENABLED_BY_TEACHER',
  TIME_FRAME_CONTENT_ENABLED_BY_STUDENT: 'TIME_FRAME_CONTENT_ENABLED_BY_STUDENT',
  EXTENDED_DUE_DATE_FOR_TASKS: 'EXTENDED_DUE_DATE_FOR_TASKS'
}